import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

const PrivateRoute = ({ children }) => {
  // アクセストークンの期限チェック
  axios.get(`${API_BASE}/api/auth/verify`, {
    withCredentials: true
  }).catch((error) => {
    if (error.status === 401) {
      // 認証エラー(401 Unauthorized)
      window.location.href = '/login';
    }
  });
  return children;
};

export default PrivateRoute;
